/**
 * Returns the correct base URL for API calls.
 * - In local dev (localhost/127.0.0.1): uses REACT_APP_BACKEND_URL
 * - In any deployed environment: uses relative URLs (same origin)
 */
const isLocalDev = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
     window.location.hostname === '127.0.0.1');

export const getApiBaseUrl = () =>
    isLocalDev ? (process.env.REACT_APP_BACKEND_URL || '') : '';

/**
 * Returns the correct WebSocket URL.
 * - In local dev: derives from REACT_APP_BACKEND_URL
 * - In deployed: uses current window.location
 */
export const getWsBaseUrl = () => {
    if (isLocalDev) {
        const url = process.env.REACT_APP_BACKEND_URL || '';
        return url.replace(/^https/, 'wss').replace(/^http/, 'ws');
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}`;
};
